import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const QuoteUpdate = ({
  headerBase64,
  footerBase64,
  dgSignBase64,
  watermarkBase64,
  quotation,
  enquiry,
  quotationData,
  invoice_date,
  grandTotal,
  numberToWords,
  selectedValue,
  type,
  bankAc,
  invoice_no,
  tax_type,
  tax_id,
  quoteTitle
}) => {
  console.log('quotationData++', quotationData);
  console.log('quotation---', quotation);
  const supply_add = quotation?.supply_add || "";
  const valid_date = quotation?.vaild_date || "";

  const doc = new jsPDF('p', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 6;
  const headerHeight = 28;
  const footerHeight = 25;
  const contentTop = headerHeight + 2;
  let isFirstPage = true;

  // Light color palette only - matching QuotationInvoiceTemplate
  const colors = {
    primary: [220, 220, 220],           // Light gray (for headers)
    secondary: [0,0,0],         // Medium gray (for text)
    accent: [180, 180, 180],            // Light medium gray
    lightGray: [250, 250, 250],         // Very light gray
    mediumGray: [240, 240, 240],        // Light medium gray
    border: [210, 210, 210],            // Light border gray
    highlight: [245, 245, 245],         // Highlight gray
    textDark: [80, 80, 80]              // Darkest text color (still lighter)
  };

  const addHeader = () => {
    if (headerBase64) doc.addImage(headerBase64, 'PNG', 0, 0, pageWidth, headerHeight);
  };

  const addWatermark = () => {
    if (!watermarkBase64) return;
    const wmWidth = pageWidth / 2;
    const wmHeight = wmWidth;
    const wmX = (pageWidth - wmWidth) / 2;
    const wmY = (pageHeight - wmHeight) / 2;
    doc.setGState(new doc.GState({ opacity: 0.05 }));
    doc.addImage(watermarkBase64, 'PNG', wmX, wmY, wmWidth, wmHeight);
    doc.setGState(new doc.GState({ opacity: 1 }));
  };

  const addPageFooter = () => {
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    doc.text(
      `Page ${doc.internal.getCurrentPageInfo().pageNumber}`,
      pageWidth - margin,
      pageHeight - 5,
      { align: 'right' }
    );
    if (footerBase64) doc.addImage(footerBase64, 'PNG', 0, pageHeight - footerHeight, pageWidth, footerHeight);
  };

  const drawTopSection = (startY = contentTop) => {
    let y = startY;

    // Document title - text only, no background bar
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...colors.textDark);
    doc.text(type, pageWidth / 2, y + 5, { align: 'center' });
    y += 6; // Reduced from 8 to 6

    // Date and number section
    doc.setFillColor(...colors.lightGray);
    doc.rect(margin, y, pageWidth - 2 * margin, 8, 'F');
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    const formattedDate = invoice_date ? new Date(invoice_date).toLocaleDateString("en-GB") : new Date().toLocaleDateString("en-GB");
    doc.text(`Date: ${formattedDate}`, margin + 3, y + 5.5);
    const invoiceNum = type === 'INVOICE' ? invoice_no || '-' : quotation.qu_no || '-';
    doc.text(`${type} No: ${invoiceNum}`, pageWidth - margin - 3, y + 5.5, { align: 'right' });
    y += 8; // Reduced from 12 to 10

    // Customer Details section with Shipping Address side by side (card design)
    const leftBoxWidth = (pageWidth - 2 * margin - 5) / 2;
    const rightBoxWidth = leftBoxWidth;
    const leftBoxX = margin;
    const rightBoxX = leftBoxX + leftBoxWidth + 5;

    const cardStartY = y;
    
    // Calculate actual content heights (not fixed heights)
    let leftContentLines = 0;
    let rightContentLines = 0;

    // Calculate left side lines (Valid Till + Shipping Address if available)
    leftContentLines = 1; // Valid Till line
    if (supply_add && supply_add.trim()) {
      const shippingLines = doc.splitTextToSize(supply_add, leftBoxWidth - 10);
      leftContentLines += 1 + shippingLines.length; // header + content lines
    }

    // Calculate right side lines (Customer Details)
    const addrValue = enquiry.address || "-";
    const addrLines = doc.splitTextToSize(addrValue, rightBoxWidth - 10 - doc.getTextWidth("Address: "));
    rightContentLines = 1 + 1 + addrLines.length + 1 + 1; // header + name + address lines + contact + gstin

    // Use the maximum number of lines to determine card height
    const maxLines = Math.max(leftContentLines, rightContentLines);
    const cardHeight = 5 + (maxLines * 4.5); // Reduced from 7 + (maxLines * 5.5) to 5 + (maxLines * 4.5)

    // Left Card - Valid Till & Shipping Address
    doc.setFillColor(...colors.lightGray);
    doc.setDrawColor(...colors.lightGray);
    doc.setLineWidth(0.1);
    doc.roundedRect(leftBoxX, cardStartY, leftBoxWidth, cardHeight, 2, 2, 'FD');
    
    let leftY = cardStartY + 5; // Reduced from 7 to 5
    
    // Valid Till
    if (valid_date) {
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0, 0, 0);
      const validTillDate = new Date(valid_date).toLocaleDateString("en-GB");
      doc.text(`Valid Till: ${validTillDate}`, leftBoxX + 5, leftY);
      leftY += 4.5; // Reduced from 5.5 to 4.5
    }
    
    // Shipping Address
    if (supply_add && supply_add.trim()) {
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0, 0, 0);
      doc.text('Shipping Address:', leftBoxX + 5, leftY);
      leftY += 4.5; // Reduced from 5.5 to 4.5
      
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(0, 0, 0);
      
      const shippingLines = doc.splitTextToSize(supply_add, leftBoxWidth - 10);
      shippingLines.forEach((line) => {
        doc.text(line, leftBoxX + 5, leftY);
        leftY += 4.5; // Reduced from 5.5 to 4.5
      });
    }

    // Right Card - Customer Details
    doc.setFillColor(...colors.lightGray);
    doc.setDrawColor(...colors.lightGray);
    doc.setLineWidth(0.1);
    doc.roundedRect(rightBoxX, cardStartY, rightBoxWidth, cardHeight, 2, 2, 'FD');
    
    let rightY = cardStartY + 5; // Reduced from 7 to 5
    
    // Customer Details Label
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('Customer Details:', rightBoxX + 5, rightY);
    rightY += 4.5; // Reduced from 5.5 to 4.5
    
    // Customer Name
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0);
    doc.text(enquiry.name || "-", rightBoxX + 5, rightY);
    rightY += 4.5; // Reduced from 5.5 to 4.5
    
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    
    // Address
    let label = "Address: ";
    doc.setFont("helvetica", "bold");
    const addrLabelWidth = doc.getTextWidth(label);
    doc.text(label, rightBoxX + 5, rightY);
    doc.setFont("helvetica", "normal");
    addrLines.forEach((l, idx) => {
      if (idx === 0) {
        doc.text(l, rightBoxX + 5 + addrLabelWidth, rightY);
      } else {
        rightY += 4.5; // Reduced from 5.5 to 4.5
        doc.text(l, rightBoxX + 5 + addrLabelWidth, rightY);
      }
    });
    rightY += 4.5; // Reduced from 5.5 to 4.5
    
    // Contact
    label = "Contact: ";
    doc.setFont("helvetica", "bold");
    doc.text(label, rightBoxX + 5, rightY);
    doc.setFont("helvetica", "normal");
    doc.text(enquiry.mobile_no || "-", rightBoxX + 5 + doc.getTextWidth(label), rightY);
    rightY += 4.5; // Reduced from 5.5 to 4.5
    
    // GSTIN
    label = "GSTIN: ";
    doc.setFont("helvetica", "bold");
    doc.text(label, rightBoxX + 5, rightY);
    doc.setFont("helvetica", "normal");
    doc.text(tax_id || enquiry.tax_id || "-", rightBoxX + 5 + doc.getTextWidth(label), rightY);
    // table and Customer Details card between space
    y = cardStartY + cardHeight + 1; // Reduced from 5 to 3
    return y;
  };

  // First page setup
  addHeader();
  addWatermark();
  let tableStartY = drawTopSection();

  // Quote Title Header (above table)
  if (quoteTitle) {
    doc.setFillColor(...colors.mediumGray);
    doc.rect(margin, tableStartY, pageWidth - 2 * margin, 8, 'F');
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text(quoteTitle, pageWidth / 2, tableStartY + 5.5, { align: 'center' });
    tableStartY += 8; // Reduced from 10 to 8
  }

  /* -------------------- TAX CALCULATION -------------------- */
  let supplySubTotal = 0;
  let installSubTotal = 0;
  
  quotationData.forEach(section => {
    section.items?.forEach(item => {
      const qty = parseFloat(item.qty) || 0;
      const supplyRate = parseFloat(item.supply_rate) || 0;
      const installRate = parseFloat(item.install_rate) || 0;
      
      supplySubTotal += qty * supplyRate;
      installSubTotal += qty * installRate;
    });
  });

  // Round to 2 decimal places
  supplySubTotal = Math.round(supplySubTotal * 100) / 100;
  installSubTotal = Math.round(installSubTotal * 100) / 100;

  // Calculate tax on each separately
  const taxPercent = quotation?.tax || 0;
  const supplyTax = Math.round((supplySubTotal * taxPercent) / 100 * 100) / 100;
  const installTax = Math.round((installSubTotal * taxPercent) / 100 * 100) / 100;

  const supplyTotal = Math.round((supplySubTotal + supplyTax) * 100) / 100;
  const installTotal = Math.round((installSubTotal + installTax) * 100) / 100;
  const finalTotal = Math.round((supplyTotal + installTotal) * 100) / 100;

  /* -------------------- TABLE WITH CHILD-PARENT STRUCTURE -------------------- */
  const bodyRows = [];

  quotationData.forEach((section, sectionIndex) => {
    /* -------- SECTION HEADER (PARENT) -------- */
    if (section.type === "service") {
      bodyRows.push([
        {
          content: sectionIndex + 1,
          styles: { fontStyle: "bold", halign: "center" }
        },
        {
          content: "SERVICES",
          colSpan: 8,
          styles: {
            fontStyle: "bold",
            fillColor: colors.mediumGray,
            textColor: colors.textDark
          }
        }
      ]);
    }

    if (section.type === "product") {
      bodyRows.push([
        {
          content: section.si_no,
          styles: { fontStyle: "bold", halign: "center" }
        },
        {
          content: section.cat_name,
          colSpan: 8,
          styles: {
            fontStyle: "bold",
            fillColor: colors.lightGray,
            textColor: colors.textDark
          }
        }
      ]);
    }

    /* -------- ITEMS (CHILDREN) -------- */
    section.items?.forEach((item) => {
      const qty = parseFloat(item.qty) || 0;
      const supplyRate = parseFloat(item.supply_rate) || 0;
      const installRate = parseFloat(item.install_rate) || 0;
      const supplyAmt = qty * supplyRate;
      const installAmt = qty * installRate;
      
      bodyRows.push([
        item.si_no || "",
        item.description || "-",
        item.sku || "-",
        qty > 0 ? qty.toFixed(0) : "",
        item.unit || "",
        supplyRate > 0 ? supplyRate.toLocaleString("en-IN", { minimumFractionDigits: 2 }) : "",
        supplyAmt > 0 ? supplyAmt.toLocaleString("en-IN", { minimumFractionDigits: 2 }) : "",
        installRate > 0 ? installRate.toLocaleString("en-IN", { minimumFractionDigits: 2 }) : "",
        installAmt > 0 ? installAmt.toLocaleString("en-IN", { minimumFractionDigits: 2 }) : ""
      ]);
    });
  });

  autoTable(doc, {
  startY: tableStartY,
  head: [
    [
      { content: "SI NO", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
      { content: "DESCRIPTION", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
      { content: "HSN/SAC CODE", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
      { content: "QTY", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
      { content: "UNIT", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
      { content: "SUPPLY", colSpan: 2, styles: { halign: 'center',fillColor: [196, 202, 207],  fontStyle: 'bold' } },
      { content: "INSTALLATION", colSpan: 2, styles: { halign: 'center', fillColor: [196, 202, 207], fontStyle: 'bold' } }
    ],
    [
      { content: "RATE", styles: { halign: 'center' } },
      { content: "AMOUNT", styles: { halign: 'center' } },
      { content: "RATE", styles: { halign: 'center' } },
      { content: "AMOUNT", styles: { halign: 'center' } }
    ]
  ],
    body: bodyRows,
    margin: {
      left: margin,
      right: margin,
      top: headerHeight + 1,
      bottom: footerHeight + 10
    },
    theme: 'grid',
    headStyles: {
      fillColor: colors.primary,
      textColor: colors.textDark,
      fontStyle: 'bold',
      halign: 'center',
      fontSize: 7.5,
      valign: 'middle'
    },
    bodyStyles: {
      fontSize: 8.5,
      textColor: colors.secondary
    },
    columnStyles: {
      0: { halign: 'center', cellWidth: 10 },
      1: { halign: 'left', cellWidth: 'auto' },
      2: { halign: 'center', cellWidth: 22 },
      3: { halign: 'center', cellWidth: 12 },
      4: { halign: 'center', cellWidth: 14 },
      5: { halign: 'right', cellWidth: 20 },
      6: { halign: 'right', cellWidth: 22 },
      7: { halign: 'right', cellWidth: 20 },
      8: { halign: 'right', cellWidth: 22 }
    },
    didDrawPage: (data) => {
      addWatermark();
      addPageFooter();
      if (!isFirstPage) addHeader();
      if (isFirstPage) isFirstPage = false;
    }
  });

  /* -------------------- SUMMARY BOX WITH BANK DETAILS SIDE BY SIDE -------------------- */
  let currentY = doc.lastAutoTable.finalY + 0.2; // Reduced from 6 to 4
  const summaryWidth = 80;
  const summaryX = pageWidth - margin - summaryWidth;

  // Build summary rows with separate supply and installation tax
  const summaryRows = [
    ["Supply Sub Total", parseFloat(supplySubTotal.toFixed(2))],
    ["Installation Sub Total", parseFloat(installSubTotal.toFixed(2))],
    [`GST (${taxPercent}%)`, parseFloat(supplyTax.toFixed(2))],
    ["Supply Total", parseFloat(supplyTotal.toFixed(2))],
    ["Installation Total", parseFloat(installTotal.toFixed(2))],
    ["Grand Total", parseFloat(finalTotal.toFixed(2))]
  ];

  // Draw summary box with light colors only
  summaryRows.forEach((row, i) => {
    const y = currentY + i * 6.3;
    if (row[0] === "Grand Total") {
      doc.setFillColor(...colors.mediumGray);
      doc.setTextColor(...colors.textDark);
      doc.setFont("helvetica", "bold");
    } else {
      doc.setFillColor(...colors.lightGray);
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "normal");
    }
    doc.rect(summaryX, y, summaryWidth, 8, "F");
    doc.text(row[0], summaryX + 4, y + 5.5);
    doc.text(
      Number(row[1]).toLocaleString("en-IN", { minimumFractionDigits: 2 }),
      summaryX + summaryWidth - 4,
      y + 5.5,
      { align: "right" }
    );
  });

  // Bank Details Section - positioned next to summary box
  if (bankAc) {
    const bankWidth = summaryX - margin - 5;
    const bankX = margin;
    let bankY = currentY;
    const lineHeight = 5.3;

    doc.setFillColor(...colors.mediumGray);
    doc.rect(bankX, bankY, bankWidth, 6, 'F');
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('BANK DETAILS', bankX + 2, bankY + 4.5);
    bankY += 10;

    doc.setFontSize(8.5);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);

    const bankLines = [
      `Account Holder: ${bankAc.holder_name || ''}`,
      `Bank: ${bankAc.bank_name || ''}`,
      `Account No: ${bankAc.ac_no || ''}`,
      `IFSC: ${bankAc.ifsc_code || ''}`,
      `${(bankAc.bank_address || '').replace(/\n/g, ' ')}`
    ];

    bankLines.forEach(line => {
      const wrapped = doc.splitTextToSize(line, bankWidth - 4);
      wrapped.forEach(part => {
        doc.text(part, bankX + 2, bankY);
        bankY += lineHeight;
      });
    });
  }

  currentY += summaryRows.length * 6.7 + 0; // Reduced from 6 to 4

  /* -------------------- GRAND TOTAL IN WORDS - Minimized Box -------------------- */
  const wordsBoxY = currentY;
  const wordsBoxWidth = pageWidth - 2 * margin;
  const wordsBoxHeight = 10; // Reduced from 12 to 10
  
  // Draw highlighted box - light colors only
  doc.setFillColor(...colors.highlight);
  // doc.setDrawColor(...colors.border);
  doc.setLineWidth(0.3);
  doc.roundedRect(margin, wordsBoxY, wordsBoxWidth, wordsBoxHeight, 2, 3, 'FD');
  
  // Title
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(0, 0, 0);
  doc.text("Grand Total (In Words):", margin + 3, wordsBoxY + 3.5); // Reduced padding
  
  // Amount in words
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8.5);
  doc.setTextColor(0, 0, 0);
  const formattedTotal = parseFloat(finalTotal.toFixed(2));
  const rupees = Math.floor(formattedTotal);
  const paise = Math.round((formattedTotal - rupees) * 100);
  
  let words = numberToWords(rupees);
  if (paise > 0) {
    words += ` and ${numberToWords(paise)} Paise`;
  }
  words += " Only";
  
  const wrappedWords = doc.splitTextToSize(words, wordsBoxWidth - 8);
  doc.text(wrappedWords, margin + 3, wordsBoxY + 7); // Adjusted position
  // After Grand Total (In Words box)
  currentY = wordsBoxY + wordsBoxHeight + 1; // Reduced spacing from 4 to 3

  // Parse terms and conditions
  let finalTerms = [];
  if (selectedValue?.data) {
    const html = selectedValue.data;
    const withLineBreaks = html
      .replace(/<li[^>]*>/gi, "\n")
      .replace(/<\/li>/gi, "")
      .replace(/<p[^>]*>/gi, "\n")
      .replace(/<div[^>]*>/gi, "\n")
      .replace(/<\/p>/gi, "")
      .replace(/<\/?[^>]+(>|$)/g, "")
      .trim();
    finalTerms = withLineBreaks
      .split("\n")
      .map(line => line.trim())
      .filter(line => line.length > 0);
  }

  /* -------------------- TERMS & CONDITIONS -------------------- */
  const termsLineHeight = 5.5; // Reduced from 5.5 to 4.8
  const termsWidth = pageWidth - 2 * margin;
  const leftX = margin;
  
  const sigWidth = pageWidth * 0.15;
  const sigHeight = sigWidth * 0.9;
  const signatureSpaceNeeded = dgSignBase64 ? sigHeight + 4 : 6;
  
  if (finalTerms.length > 0) {
    let termsY = currentY;
    
    if (termsY + 16 > pageHeight - footerHeight - 5) {
      addPageFooter();
      doc.addPage();
      addHeader();
      addWatermark();
      termsY = headerHeight + 15;
    }
    
    // Draw terms header
    doc.setFillColor(...colors.mediumGray);
    doc.rect(leftX, termsY, termsWidth, 6, 'F');
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('TERMS & CONDITIONS', leftX + 2, termsY + 4.5);
    termsY += 8; // Reduced from 10 to 8

    doc.setFontSize(8.5);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);

    finalTerms.forEach((line) => {
      const wrapped = doc.splitTextToSize(line, termsWidth - 6);
      
      wrapped.forEach((wrappedLine, wIndex) => {
        if (termsY + termsLineHeight > pageHeight - footerHeight - 5) {
          addPageFooter();
          doc.addPage();
          addHeader();
          addWatermark();
          termsY = headerHeight + 15;
        }
        
        const bullet = wIndex === 0 ? '• ' : '  ';
        doc.text(`${bullet}${wrappedLine}`, leftX + 3, termsY);
        termsY += termsLineHeight;
      });
    });
    
    currentY = termsY + 1;
  }

  /* -------------------- SIGNATURE SECTION -------------------- */
  const availableSpace = pageHeight - footerHeight - currentY - 3;
  
  if (availableSpace < signatureSpaceNeeded) {
    addPageFooter();
    doc.addPage();
    addHeader();
    addWatermark();
    currentY = headerHeight + 15;
  }

  const sigX = pageWidth - sigWidth - margin;
  const sigY = currentY;

  if (dgSignBase64) {
    doc.addImage(dgSignBase64, "PNG", sigX, sigY, sigWidth, sigHeight);
    doc.setFontSize(7.5);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text("Authorized Signatory", sigX, sigY + sigHeight + 2.5);
  } else {
    doc.setFontSize(8.5);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text("Authorized Signatory", sigX, sigY);
  }

  addPageFooter();
  return doc;
};

export default QuoteUpdate;